import React from 'react'
import './Products.css'

const ProductsSpeaker = () => {
    return (
        <div className='products_container'>
            <div className='block'>
                <div className='first'>
                    <img src="/images/speakers/1.jpg" alt="First" />
                    <h1>WILLEN</h1>
                </div>
                <div className='second'>
                    <img src="/images/speakers/2.jpg" alt="Second" />
                    <h1>EMBERTON II</h1>
                </div>
            </div>
            <div className='block'>
                <div className='first'>
                    <img src="/images/speakers/3.jpg" alt="Third" />
                    <h1>EMBERTON</h1>
                </div>
                <div className='second'>
                    <img src="/images/speakers/4.jpg" alt="Fourth" />
                    <h1>EMBERTON</h1>
                </div>
            </div>
            <div className='block'>
                <div className='first'>
                    <img src="/images/speakers/5.jpg" alt="Fifth" />
                    <h1>ACTON III</h1>
                </div>
                <div className='second'>
                    <img src="/images/speakers/6.jpg" alt="Sixth" />
                    <h1>STANMORE III</h1>
                </div>
            </div>
            <div className='block'>
                <div className='first'>
                    <img src="/images/speakers/7.jpg" alt="Seventh" />
                    <h1>KILBURN II</h1>
                </div>
                <div className='second'>
                    <img src="/images/speakers/8.jpg" alt="Eight" />
                    <h1>STOCKWELL II</h1>
                </div>
            </div>
            <div className='block'>
                <div className='first'>
                    <img src="/images/speakers/9.jpg" alt="Ninth" />
                    <h1>TUFTON</h1>
                </div>
                <div className='second'>
                    <img src="/images/speakers/10.jpg" alt="Tenth" />
                    <h1>WOBURN III</h1>
                </div>
            </div>
        </div>
    )
}

export default ProductsSpeaker